import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export const Input = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement>
>(({ className, ...rest }, ref) => (
  <input
    ref={ref}
    className={cn(
      'h-12 w-full rounded-xl border border-surface-divider bg-transparent px-4 text-sm text-fg placeholder:text-fg-subtle',
      'focus:outline-none focus:border-brand-red',
      'disabled:cursor-not-allowed disabled:opacity-60',
      'aria-[invalid=true]:border-state-danger',
      className,
    )}
    {...rest}
  />
));
Input.displayName = 'Input';
